export default "__VITE_ASSET__$l_uFZqY__"